const OpeningHours = () => {
  document.addEventListener('DOMContentLoaded', () => {
    // 1. Add this block to check for "Closed" and add the class
    const closedSpans = document.querySelectorAll('.opening-times__row span');
    closedSpans.forEach((span) => {
      // Trim in case of leading/trailing spaces
      if (span.textContent.trim() === 'Closed') {
        span.classList.add('closed');
      }
    });

    // 2. Existing code to set up accordion behavior
    const headings = document.querySelectorAll('.opening-times__heading');
    const contents = document.querySelectorAll('.opening-times__content');

    // Check if headings and contents exist
    if (headings.length === 0 || contents.length === 0) return;

    // Loop through each heading/content pair
    headings.forEach((heading, index) => {
      const content = contents[index];
      const arrow = heading.querySelector('.opening-times__arrow');

      // Check if heading, content, and arrow are found
      if (!heading || !content || !arrow) return;

      const toggleAccordion = () => {
        // Check if the screen width is below 1023px
        if (window.innerWidth <= 1023) {
          const isOpen = content.classList.toggle('open');

          // Rotate the arrow
          arrow.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';

          // Update the aria-expanded attribute based on the state
          heading.setAttribute('aria-expanded', isOpen);
        }
      };

      // Add event listener for clicking on the heading
      heading.addEventListener('click', () => {
        toggleAccordion();
      });

      // Optional: Close the accordion if the window is resized above 1023px
      window.addEventListener('resize', () => {
        if (window.innerWidth > 1023) {
          content.classList.remove('open');
          heading.setAttribute('aria-expanded', 'true');
          arrow.style.transform = 'rotate(0deg)';
        }
      });
    });
  });
};

export default OpeningHours;
